// extracted by mini-css-extract-plugin
export default {"control_panel_container":"styles_control_panel_container__GPZqb","panel_left":"styles_panel_left__nzR55","panel_right":"styles_panel_right__QSc5a"};